export default __webpack_public_path__ + "static/media/Charan.3430fa41.png";